import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import login from '@/pages/login/login'
import sms_code from '@/pages/login/sms_code'
import repayment from '@/pages/repayment/repayment'
import repayment_detail from '@/pages/repayment/repayment_detail'
import repayment_methods from '@/pages/repayment/repayment_methods'
import repayment_ussd from '@/pages/repayment/repayment_ussd'
import repayment_qr from '@/pages/repayment/repayment_qr'
import repayment_virtual from '@/pages/repayment/repayment_virtual'
import bind_bank_card from '@/pages/bankcard/bind_bank_card'
import pay_result from '@/pages/result/pay_result'
import third_page from '@/pages/third/third_page'
import contact_us from '@/pages/system/contactUs'
import contact from '@/pages/personalCenter/contact'
import apply from './apply'
import home from '@/pages/home/index'

import { getQuery } from '@/utils/tools.js'

const routes = [
  {
    path: '/',
    redirect: () => {
      const token = getQuery('token')
      if (token) {
        sessionStorage.setItem('token', token)
        return 'home'
      } else {
        return 'login'
      }
      // let token = sessionStorage.getItem("token")
      // let memberId = sessionStorage.getItem("memberId")
      // let phone = sessionStorage.getItem("phone")
      // if (token && memberId && phone) {
      //     return 'repayment'
      // }
      // return 'login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'hcash'
      next()
    }
  },
  {
    path: '/sms_code',
    name: 'sms_code',
    component: sms_code,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'sms_code'
      next()
    }
  },
  {
    path: '/repayment',
    name: 'repayment',
    component: repayment,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment'
      next()
    }
  },
  {
    path: '/repayment_detail',
    name: 'repayment_detail',
    component: repayment_detail,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment_detail'
      next()
    }
  },
  {
    path: '/repayment_methods',
    name: 'repayment_methods',
    component: repayment_methods,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment_methods'
      next()
    }
  },
  {
    path: '/repayment_ussd',
    name: 'repayment_ussd',
    component: repayment_ussd,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment_ussd'
      next()
    }
  },
  {
    path: '/repayment_qr',
    name: 'repayment_qr',
    component: repayment_qr,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment_qr'
      next()
    }
  },
  {
    path: '/repayment_virtual',
    name: 'repayment_virtual',
    component: repayment_virtual,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'repayment_virtual'
      next()
    }
  },
  {
    path: '/bind_bank_card',
    name: 'bind_bank_card',
    component: bind_bank_card,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'bind_bank_card'
      next()
    }
  },
  {
    path: '/pay_result',
    name: 'pay_result',
    component: pay_result,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'pay_result'
      next()
    }
  },
  {
    path: '/third_page',
    name: 'third_page',
    component: third_page,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'third_page'
      next()
    }
  },
  {
    path: '/contact_us',
    name: 'contact_us',
    component: contact_us,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'Contact us'
      next()
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact,
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = 'Contact'
      next()
    }
  },
  { path: '/home', name: 'home', component: home },
  ...apply
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  let landPageId = getQuery('landPageId')
  landPageId && sessionStorage.setItem('landPageId', landPageId)
  next()
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default router
